import React, {useRef, useState} from 'react';
import {useField, useFormikContext} from 'formik';
import SelectSvgSelector from '../../../Components/InputSelect/SelectSvgSelector';
import MyCalendar from '../../../Components/Calendar/Calendar';
import {useClickOutside} from '../../../hooks/useClickOutside';
import commonStyle from '../../../assets/common/CommonStyle.module.css';
import s from '../RegistrationNewClient.module.css';
import ErrorMessage from './ErrorMessage';

interface CalendarFieldProps {
	name: string;
	placeholder: string;
}

const CalendarField: React.FC<CalendarFieldProps> = ({name, placeholder}) => {
	const [field] = useField(name);
	const {setFieldValue, status} = useFormikContext<any>();
	const error = status?.[name];
	const [openCalendar, setOpenCalendar] = useState(false);
	const calendarFieldRef = useRef<HTMLDivElement>(null);

	const handleCloseCalendar = () => {
		setOpenCalendar(false);
	};

	const calendarRef = useClickOutside<HTMLDivElement>(handleCloseCalendar);

	return (
		<div style={{position: 'relative'}}>
			<div
				ref={calendarFieldRef}
				role="button"
				tabIndex={0}
				className={`${commonStyle.fieldContainer} ${s.selectLikeControl} ${error && s.errorField}`}
				onClick={(e) => {
					e.stopPropagation();
					setOpenCalendar(!openCalendar);
				}}
			>
				<SelectSvgSelector id={'calendar'} />
				<input {...field} placeholder={placeholder} />
			</div>
			{openCalendar && (
				<div className={s.calendarContainer} ref={calendarRef}>
					<MyCalendar 
						fieldName={name} 
						setFieldValue={setFieldValue} 
						onDateSelected={handleCloseCalendar}
					/>
				</div>
			)}
			<ErrorMessage message={error} />
		</div>
	);
};

export default CalendarField;
